module.exports = __webpack_public_path__ + "static/media/part_of_larv_small.f268bdee.jpg";